export interface WidgetConfig {
    bot_name: string;
    /** Optional small line under the bot name in the header. Empty or
     *  missing → the widget's own localized "AI assistant" wording. */
    subtitle?: string;
    primary_color: string;
    /** Optional image used inside the round launcher button — and, when
     *  set, as the avatar next to the bot name in the header. When empty
     *  or missing, the widget falls back to its built-in chat icon. */
    bubble_image_url?: string;
    greeting: string;
    options: { title: string; value: string }[];
    locale_default: "nl" | "fr" | "en";
    /** Platform maker credited in the footer. Optional: a widget built
     *  after this field shipped can still run against an older services
     *  instance that doesn't send it — the footer is simply omitted. */
    maker?: { slug: string; name: string; url: string };
    /** Seconds after init before the teaser bubble appears next to the
     *  closed launcher; 0 = off. Optional like `maker`: an older services
     *  instance doesn't send it, and then there is simply no teaser. */
    teaser_delay_seconds?: number;
    /** Plain-text teaser. Empty or missing → the greeting is shown. */
    teaser_message?: string;
}

export async function fetchWidgetConfig(
    baseUrl: string,
    widgetToken: string,
): Promise<WidgetConfig> {
    const res = await fetch(
        `${baseUrl}/v1/api/chat/config?widget_token=${encodeURIComponent(widgetToken)}`,
        { method: "GET" },
    );
    if (!res.ok) {
        throw new Error(`widget config request failed: HTTP ${res.status}`);
    }
    const body = await res.json();
    if (!body?.success || !body?.data) {
        throw new Error("widget config response malformed");
    }
    return body.data as WidgetConfig;
}
